<div class="announcement-bar relative z-50 px-4 py-2.5 text-center">
	<p class="font-display text-xs text-white/85 md:text-sm">
		<span class="text-blue-soft text-[10px] font-medium uppercase tracking-wider md:text-xs">
			Free Forever
		</span>
		<span class="mx-2 hidden text-white/30 md:inline">·</span>
		<span class="hidden md:inline">First 5 devices on us | no credit card, no trial clock.</span>
		<a
			href="/pricing"
			class="ml-1 underline decoration-white/30 underline-offset-2 transition hover:text-white hover:decoration-white"
		>
			See pricing →
		</a>
	</p>
</div>
